import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Checkbox,
  CheckboxContainer,
  CheckboxLabel,
  ErrorMessage,
  Form,
  GlobalStyle,
  Input,
  Logo,
  MainContent,
  PageContainer,
  Sidebar,
  Title,
} from "./BetaComponents";
import { formatPhoneNumberForDisplay, handlePhoneNumberChange, sanitizePhoneNumber } from "./PhoneDisplay";

const SignUpPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState(sanitizePhoneNumber(location.state?.phone_number || ''));

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!firstName || !lastName || !email) {
      setError('Please fill out all fields.');
      return;
    }
    if (phoneNumber.length !== 10) {
      setError('Please enter a valid 10-digit phone number.');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const response = await fetch('/submit-user-info', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          first_name: firstName,
          last_name: lastName,
          user_number: phoneNumber,
          user_email: email,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.detail || 'An error occurred during sign up.');
        setLoading(false);
        return;
      }

      navigate(data.redirect_url, {
        state: data.state,
      });
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  return (
    <>
      <GlobalStyle />
      <PageContainer>
        <Sidebar>
          <Logo />
        </Sidebar>
        <MainContent>
          <Title>Create Your Account</Title>
          <Form onSubmit={handleCreate}>
            <Input
              type='text'
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />
            <Input
              type='text'
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />
            <Input
              type='email'
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Input
              type='tel'
              placeholder="Your phone number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              />
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <Button type='submit' disabled={loading || !agreed}>
              {loading ? 'Creating...' : 'Create Account'}
            </Button>
            <CheckboxContainer>
              <Checkbox id="agree" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />
              <CheckboxLabel htmlFor="agree">
                I agree to the{" "}
                <a
                  href="https://call.chat/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and conditions
                </a>
              </CheckboxLabel>
            </CheckboxContainer>
          </Form>
        </MainContent>
      </PageContainer>
    </>
  );
};

export default SignUpPage;
